// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NX1U","rightAdornment":"Header_rightAdornment__3_K0K"};